import React from 'react'
import JobItem from './JobItem'
import styled from 'styled-components'

const NoJobs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4em;
  font-wieght: bold;
  height: 100px;
  color: #999;
`
// const Container = styled.div`
//   overflow-y: scroll;
//   padding-left: 2px;
// `

const Job = ({
  jobs,
  save,
  trigger,
  availableTriggers,
  hideDisabled,
  filter = '',
  error,
  setError,
  height,
}) => {
  return jobs.length > 0 ? (
    <div
      style={{
        height: height - 140 + 'px',
        // maxHeight: height - 50,
        overflowY: 'auto',
      }}
    >
      {jobs
        .filter(
          j =>
            filter.trim().length === 0 ||
            j.jobName.toLowerCase().includes(filter.toLowerCase())
        )
        .filter(j => j.active || !hideDisabled)
        .map(j => (
          <JobItem
            key={j.jobName}
            {...j}
            save={save}
            trigger={trigger}
            availableTriggers={availableTriggers}
            error={error}
            setError={setError}
          />
        ))}
    </div>
  ) : (
    <NoJobs>There are no jobs registerd</NoJobs>
  )
}

export default Job
